var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "pl-1 agenda-sidebar",
      attrs: { "justify-space-between": "" }
    },
    [
      _c(
        "v-flex",
        { staticClass: "my-3", attrs: { xs12: "", sm6: "" } },
        [
          _c("v-date-picker", {
            staticClass: "date-picket-transparent",
            attrs: {
              width: "250",
              locale: _vm.coLocale,
              "no-title": true,
              events: _vm.eventDotsDate
            },
            on: { input: _vm.handleDateChange },
            model: {
              value: _vm.dtDate,
              callback: function($$v) {
                _vm.dtDate = $$v
              },
              expression: "dtDate"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2bd1b060", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bd1b060","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/agenda/components/agenda-sidebar-date-picker/template.html
// module id = null
// module chunks = 